// return jquery object if $ or jQuery
export function getJquery() {
	return window.jQuery || window.$
}
